'use strict';

(function () {
  'use strict';

  angular.module('msAssessment').controller('AssessmentNoticeCtrl', AssessmentNoticeCtrl);

  AssessmentNoticeCtrl.$inject = ['$rootScope', '$state', '$stateParams', 'authenticationRouter', '$sessionStorage', 'userSvc', 'providerSvc', 'wellnessSvc', 'activityFlagSvc', 'assessmentRouter', 'providerContext'];

  function AssessmentNoticeCtrl($rootScope, $state, $stateParams, authenticationRouter, $sessionStorage, userSvc, providerSvc, wellnessSvc, activityFlagSvc, assessmentRouter, providerContext) {
    $rootScope.$state = $state;
    var vm = this;
    var isLoginSpa = providerContext.translatePrefix === 'login';
    vm.isConsumer = false;
    //show the skip link unless assessment is required
    vm.hideSkip = false;
    vm.skipAssessment = _skipAssessment;
    vm.translatePrefix = providerContext.translatePrefix || 'onboarding';
    vm.cobrandingText = '';
    vm.startQuestionnaireArgs = _.merge({ question: 1, assessment: 1, types: 'WELLNESS_ASSESSMENT&types=QUESTIONNAIRE' }, $stateParams);

    _activate();

    function _activate() {
      userSvc.getUser().then(_initBranding).then(_determineNextStep);
    }

    function _initBranding(user) {
      vm.cobrandingText = user.organization.name;
      vm.codeStatus = user.accessCode.status;
      providerSvc.getHeader().then(function (data) {
        var contentItem;
        if (data && data.content) {
          contentItem = data.content.filter(function (headerContent) {
            return headerContent.target === 'image';
          })[0];
          if (contentItem) {
            vm.cobranding = contentItem.replacement;
          }
        }
      });
    }

    function _determineNextStep() {
      var assessmentRequirement = _.find($sessionStorage.authRequirements, function (req) {
        return req.requirementType === 'ASSESSMENT';
      });
      //in on-boarding scenarios (e.g. a hard page refresh in sign-up),
      //auto-nav if requirement is complete
      if (vm.translatePrefix === 'onboarding') {
        if (!assessmentRequirement || assessmentRequirement.complete === true) {
          assessmentRouter.goToNextStep($stateParams);
        }
      }
      var assessmentToTake = wellnessSvc.determineUserAssessmentStatus(assessmentRequirement);
      if (assessmentToTake) {
        vm.startQuestionnaireArgs.assessment = assessmentToTake.position;
        if (assessmentToTake.requirement === 'REQUIRE_ASSESSMENT') {
          vm.hideSkip = true;
        }
      }
    }

    function _skipAssessment() {
      var totalAssessments = null;
      var assessmentIdsSkipped = [];

      wellnessSvc.getAssessments().then(function (assessments) {
        totalAssessments = Object.keys(assessments).length;
        Object.keys(assessments).map(function (assessmentKey) {
          var assessment = assessments[assessmentKey];
          return activityFlagSvc.skip({ id: assessment.id }, false).then(function () {
            assessmentSkipCompleted(assessment.id);
          }).catch(function () {
            assessmentSkipCompleted(assessment.id);
          });
        });
      });

      function assessmentSkipCompleted(assessmentId) {
        assessmentIdsSkipped.push(assessmentId);
        if (assessmentIdsSkipped.length >= totalAssessments) {
          _goToNextStep();
        }
      }
    }

    function _goToNextStep() {
      if (isLoginSpa && $rootScope.isMobileWebView) {
        $rootScope.sendWebViewPostMessage('assessmentSkip');
        return;
      }
      authenticationRouter.goToNextStep($stateParams);
    }
  }
})();